(ns frontend.ui.component.lp-portal.report.body.lifeline.fund.fund-vi.pdf
  (:require
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.report.component.block-table.pdf-view :as block-table-pdf]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.pdf-view :as horizontal-table-pdf]
   [frontend.ui.component.lp-portal.report.component.overview-figures.pdf-view :as overview-figures-pdf]
   [frontend.ui.component.lp-portal.report.component.vertical-table.pdf-view :as vertical-table-pdf]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.voima-components.pdf.card.view :as card]
   [frontend.ui.component.lp-portal.voima-components.pdf.column.view :as column]
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.component.lp-portal.report.body.lifeline.fund.common :as lifeline-common]))

;;COMPONENTS

(defn fund-update-text
  [data]
  [(card/card "Fund update"
              (text-content/rich-content (->> data
                                              :fund-update
                                              :rich-content)))])

(defn general-table
  [data]
  [(card/card
    "Fund overview"
    (block-table-pdf/table (:general data) {:font-size 7
                                            :data-cell-alignment "justify"
                                            :table-widths [90 290]
                                            :text-color (theme/color [:palette :white])}))])

(defn fund-progress-table
  [data]
  [(card/custom-margins-card
    ""
    [0 16 0 0]
    (vertical-table-pdf/table (:fund-progress data)
                              {:stacked-rows? true
                               :text-color "#FFFFFF"}))])

(defn kpis-table
  [data]
  [(card/bottom-page-card
    ""
    (overview-figures-pdf/table (-> data
                                    :kpis
                                    :figures) 8)
    (text-content/optional-footer (->> data
                                       :fund-progress-kpis-footnote)
                                  {:margin-top 5
                                   :margin-bottom 0
                                   :margin-left 0
                                   :paragraph-margin-bottom 0}))])

(defn total-investment-donut-chart-card
  [data]
  [(card/card {:title "TOTAL INVESTMENT, m€"
               :preserve-title-case? true}
              {:svg   (chart-view/chart-svg "highcharts"
                                            (-> data
                                                :chart-data-total-investment
                                                :figures))
               :width 370})])

(defn portfolio-at-fair-value-donut-chart-card
  [data]
  [(card/card {:title "PORTFOLIO AT FAIR VALUE, m€"
               :preserve-title-case? true}

              {:svg   (chart-view/chart-svg "highcharts"
                                            (-> data
                                                :chart-data-portfolio-at-fair-value
                                                :figures))
               :width 370})])

(defn investment-summary-table
  [data]
  [(card/card
    "Investment summary"
    (horizontal-table-pdf/table (->> data
                                     :investment-summary)))
   (text-content/optional-footer (->> data
                                      :investment-summary))])

(defn fund-assets-table
  [data]
  [(card/table-card
    "Fund assets"
    (vertical-table-pdf/table (:fund-assets data)
                              {:table-widths [120 75 75 75]})
    (text-content/optional-footer (->> data
                                       :fund-assets)))])

(defn fund-cash-flows-table
  [data]
  [(card/table-card
    "Fund cash flows"
    (vertical-table-pdf/table (:fund-cash-flows data)
                              {:table-widths [120 75 75 75]})
    (text-content/optional-footer (->> data
                                       :fund-cash-flows)))])

(defn management-fees-table
  [data]
  [(card/table-card
    "Management fees"
    (vertical-table-pdf/table (:management-fees data)
                              {:table-widths [120 75 75 75]})
    (text-content/optional-footer (->> data
                                       :management-fees)))])

(defn carried-interest-table
  [data]
  [(card/table-card
    "Carried interest"
    (vertical-table-pdf/table (:carried-interest data)
                              {:table-widths [120 75 75 75]})
    (text-content/optional-footer (->> data
                                       :carried-interest)))])

(defn fund-operating-expenses-table
  [data]
  [(card/table-card
    "Fund operating expenses"
    (vertical-table-pdf/table (:fund-operating-expenses data)
                              {:table-widths [120 70 70 70]})
    (text-content/optional-footer (->> data
                                       :fund-operating-expenses)))])

(defn fund-expenses-and-costs-table
  [data]
  [(card/table-card
    "Fund establishment expenses"
    (vertical-table-pdf/table (:fund-expenses-and-costs data)
                              {:table-widths [120 75 75 75]})
    (text-content/optional-footer (->> data
                                       :fund-expenses-and-costs)))])

(defn other-expenses-table
  [data]
  [(card/table-card
    "Other expenses"
    (vertical-table-pdf/table (:other-expenses data)
                              {:table-widths [120 75 75 75]})
    (text-content/optional-footer (->> data
                                       :other-expenses)))])

;;PAGES

(defn fund-overview-page
  [data]
  (page/page
   (page/third-column-background-two-thirds-height-not-rounded)
   nil
   [(column/columns-2-to-1
     [(fund-update-text data)]
     [(fund-progress-table data)])
    (kpis-table data)]))

(defn donut-chart-page
  [data]
  (page/page
   (page/first-half-column-background-lifeline-fund)
   nil
   [(column/half-columns
     [(general-table data)]
     [[(total-investment-donut-chart-card data)]
      [(portfolio-at-fair-value-donut-chart-card data)]])]))

(defn current-portfolio-page
  [data]
  (let [remove-page? (lifeline-common/all-data-rows-empty? data :current-portfolio)]
    (when-not remove-page?
      (horizontal-table-pdf/dynamic-horizontal-table-pages
       {:fund-name (:fund-name data)}
       "Current portfolio"
       (-> data
           :current-portfolio)
       {:full-width?    true
        :partition-size 25
        :odd-color      (theme/color [:pdf :table :odd-color])
        :even-color     (theme/color [:pdf :table :even-color])
        :heading-color  (theme/color [:pdf :table :heading-color])}))))

(defn exited-investment-page
  [data]
  (let [remove-page? (lifeline-common/all-data-rows-empty? data :exited-portfolio)]
    (when-not remove-page?
      (horizontal-table-pdf/dynamic-horizontal-table-pages
       {:fund-name (:fund-name data)}
       "Exited portfolio"
       (-> data
           :exited-portfolio)
       {:full-width?    true
        :partition-size 25
        :odd-color      (theme/color [:pdf :table :odd-color])
        :even-color     (theme/color [:pdf :table :even-color])
        :heading-color  (theme/color [:pdf :table :heading-color])}))))

(defn investment-summary-page
  [data]
  (page/page
   nil
   [(investment-summary-table data)]))

(defn investors-page
  [data]
  (let [remove-page? (lifeline-common/all-data-rows-empty? data :investors)]
    (when-not remove-page?
      (horizontal-table-pdf/dynamic-horizontal-table-pages
       {:fund-name (:fund-name data)}
       "Investors"
       (->> data
            :investors)
       {:full-width?    true
        :partition-size 25
        :odd-color      (theme/color [:pdf :table :odd-color])
        :even-color     (theme/color [:pdf :table :even-color])
        :heading-color  (theme/color [:pdf :table :heading-color])}))))

(defn capital-account-since-inception-page
  [data]
  (let [remove-page? (lifeline-common/all-data-rows-empty? data :capital-account-since-inception)]
    (when-not remove-page?
      (horizontal-table-pdf/dynamic-horizontal-table-pages
       {:fund-name (:fund-name data)}
       "Capital account since inception"
       (->> data
            :capital-account-since-inception)
       {:full-width?    true
        :partition-size 25
        :odd-color      (theme/color [:pdf :table :odd-color])
        :even-color     (theme/color [:pdf :table :even-color])
        :heading-color  (theme/color [:pdf :table :heading-color])}))))


(defn capital-account-quarter-to-date-page
  [data]
  (let [remove-page? (lifeline-common/all-data-rows-empty? data :capital-account-quarter-to-date)]
    (when-not remove-page?
      (horizontal-table-pdf/dynamic-horizontal-table-pages
       {:fund-name (:fund-name data)}
       "Capital account quarter to date"
       (-> data
           :capital-account-quarter-to-date)
       {:full-width?    true
        :partition-size 25
        :odd-color      (theme/color [:pdf :table :odd-color])
        :even-color     (theme/color [:pdf :table :even-color])
        :heading-color  (theme/color [:pdf :table :heading-color])}))))

(defn cash-flows-assets-and-fees-page
  [data]
  (page/page
   nil
   [(column/half-columns
     [(fund-cash-flows-table data)
      (fund-assets-table data)]
     [(carried-interest-table data)
      (management-fees-table data)])]))

(defn cash-flows-assets-and-fees-page-2
  [data]
  (page/page
   nil
   [(column/half-columns
     [(fund-expenses-and-costs-table data)
      (fund-operating-expenses-table data)]
     [(other-expenses-table data)])]))

(defn fund-pages
  [data]
  (concat
   (lifeline-common/toc-page-with-table {:cover-image :front-page-image
                                         :report-data data})
   [(fund-overview-page data)]
   [(donut-chart-page data)]
   (current-portfolio-page data)
   (exited-investment-page data)
   [(investment-summary-page data)]
   (investors-page data)
   (capital-account-since-inception-page data)
   (capital-account-quarter-to-date-page data)
   [(cash-flows-assets-and-fees-page data)]
   [(cash-flows-assets-and-fees-page-2 data)]))
